export default __webpack_public_path__ + "static/media/notification_icon.bf28945e.svg";